import { clsx } from 'clsx'
import {
  arrowBase,
  arrowColor,
  arrowHorizontal,
  arrowVertical,
  bubbleBase,
  bubbleVariants,
} from './index.css'

export type ArrowPosition = {
  vertical: 'top' | 'bottom'
  horizontal: 'left' | 'middle' | 'right'
}

export const BubbleWithArrow = (props: {
  arrowPosition: ArrowPosition | null
  className?: string
  variant: 'user' | 'other'
  children: React.ReactNode
}) => {
  return (
    <div
      className={clsx(
        bubbleBase,
        bubbleVariants[props.variant],
        props.className,
      )}
    >
      {props.children}
      {props.arrowPosition ? (
        <div
          className={clsx(
            arrowBase,
            arrowVertical[props.arrowPosition.vertical],
            arrowHorizontal[props.arrowPosition.horizontal],
            arrowColor[props.variant],
          )}
        />
      ) : null}
    </div>
  )
}
